import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../i18n/index.js';

export function LocaleSwitcher() {
  const { t } = useTranslation('shell');
  const { locale, options, setLocale } = useLocale();
  const blurAfterPointerChangeRef = useRef(false);

  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <span
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {t('language.label')}
      </span>
      <select
        aria-label={t('language.label')}
        value={locale}
        onPointerDown={() => {
          blurAfterPointerChangeRef.current = true;
        }}
        onKeyDown={() => {
          blurAfterPointerChangeRef.current = false;
        }}
        onChange={(event) => {
          setLocale(event.target.value as typeof locale);
          if (blurAfterPointerChangeRef.current) {
            blurAfterPointerChangeRef.current = false;
            event.currentTarget.blur();
          }
        }}
        onBlur={() => {
          blurAfterPointerChangeRef.current = false;
        }}
        style={{
          height: 32,
          maxWidth: 120,
          borderRadius: 'var(--r-1)',
          border: '1px solid var(--border-1)',
          background: 'var(--bg-1)',
          color: 'var(--fg-1)',
          fontFamily: 'var(--font-ui)',
          fontSize: 12,
          padding: '0 8px',
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
